import { ErrorHandler, Injectable, Injector } from '@angular/core';
import { HttpErrorResponse } from '@angular/common/http';
import { Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { CookieService } from 'ngx-cookie-service';
import { ConfigService } from './config.service';
import { LoginStatusResponse } from '../login/login.status.response';
import { DirectLoggedOut, DirectUserRoleHasBeenChanged } from '../login/core.actions';
import { HeaderAlertService } from '../header-alert/header-alert.service';

@Injectable()
export class ErrorsHandler implements ErrorHandler {

  constructor(
    private readonly cookieService: CookieService,
    private readonly injector: Injector,
    private readonly initService: ConfigService
  ) {}

  handleError(error: Error) {
    if (error instanceof HttpErrorResponse) {
      switch (error.status) {
        case 401:
          console.log('error code: ', error.error.code);
          this.caseServiceUnauthorised(error);     
          break;

        case 403:
          // logout by reason - unsigned agreement
          if (+error.error.code === 40 || +error.error.code === 42 || +error.error.code === 50) {
            this.store.dispatch(new DirectUserRoleHasBeenChanged());
          }
          break;

        case 404:
          this.casePageNotFoundError(error);

          break;

        case 500:
        case 501:
        case 502:
          this.alertError();
          break;

        case 503:
          this.caseServiceUnavailableError(error);
          break;

        case 0:
          this.caseErrorDefault(error);
          if (error.statusText === 'Unknown Error') {
            this.alertError();
          }
          break;
      }
    } else {
      // TODO
    }
  }

  alertError() {
    this.alertService.clean();
    this.alertService.add({
      type: 'error',
      content: $localize`:@@erros-handler.pageSomethingwentwrongHeading:Oops... Something went wrong`,
      translate: true
    });
  }

  get router(): Router {
    return this.injector.get(Router);
  }

  get store(): Store<any> {
    return this.injector.get(Store);
  }

  get alertService(): HeaderAlertService {
    return this.injector.get(HeaderAlertService);
  }

  caseErrorDefault(error: HttpErrorResponse) {
    if (error.error.currentTarget) {
      if (
        error.url.indexOf(this.initService.getEnvConfig().AD_MAGENTO_URL) !== -1 || 
        error.url.indexOf(this.initService.getEnvConfig().AD_JAVA_API_URL) !== -1
      ) {
        this.router.navigate(['/maintenance']);
        return;
      }

      if (error.url.indexOf(this.initService.getEnvConfig().API.registration.eloqua) !== -1) {
        return;
      }
    }
  }

  caseServiceUnavailableError(error: HttpErrorResponse) {
    if (error.url.indexOf(this.initService.getEnvConfig().AD_MAGENTO_URL) !== -1 || 
        error.url.indexOf(this.initService.getEnvConfig().AD_JAVA_API_URL) !== -1) {
        this.router.navigate(['/maintenance']);
    } else {
      this.alertError();
    }
  }

  casePageNotFoundError(error: HttpErrorResponse) {
    // TODO temporary check for MMMW2-5541
    if (error.url.indexOf('/amadeus/public/news/post/') === -1) {
      this.router.navigate(['/404']);
  }
}

  caseServiceUnauthorised(error: HttpErrorResponse) {
    if (error.url === this.initService.getEnvConfig().AD_JAVA_API_URL) {
      this.router.navigate(['/']);
    } else if (LoginStatusResponse.TOKEN_EXPIRED === error.error.code) {
      this.cookieService.delete('restoreToken');
      this.cookieService.delete('profile');
      localStorage.removeItem('accessToken');
      localStorage.removeItem('idToken');
      this.store.dispatch(new DirectLoggedOut({}));
    }
  }
}